// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"preview-wrapper--qi0bt"};